// Dependencies
import styled, { css } from 'styled-components';

type AccordionStylesProps = {
  isActive: boolean;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const AccordionItemWrapper = styled.div<AccordionStylesProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 104px;
  padding: 16px;
  gap: 16px;
  border-radius: 24px;
  background-color: #fafafc;
  transition: all 0.3s;
  cursor: pointer;
  user-select: none;

  @media (min-width: 768px) {
    padding: 24px 32px 24px 32px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      max-height: 300px;
    `};
`;

export const AccordionItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #25272D;
`;

export const AccordionItemContent = styled.div<AccordionStylesProps>`
  display: block;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #666b7b;
  transition: all 0.3s;
  max-height: 0;
  overflow: hidden;

  > ul {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    margin-left: 6px;
    list-style-type: '- ';
  }

  ${({ isActive }) =>
    isActive &&
    css`
      max-height: 300px;
    `};
`;

export const AccordionIcon = styled.img<AccordionStylesProps>`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  transform: rotate(180deg);
  transition: all 0.3s;

  ${({ isActive }) =>
    isActive &&
    css`
      transform: rotate(0);
    `}
`;
